<mat-card [ngStyle]="{ width: width + 'px', height: height + 'px' }" *ngIf="haswrapper">
  <mat-card-header>
    <mat-card-title class="mat-card-title">{{ wconfig.config.title }}</mat-card-title>
  </mat-card-header>
  <template #target></template>
</mat-card>
<div [ngStyle]="{ width: width + 'px', height: height + 'px' }" *ngIf="!haswrapper">
  <template #target></template>
</div>
